import React from 'react';
import { User } from 'lucide-react';
export function Header() {
  return <header className="bg-white border-b border-gray-200" data-id="element-32">
      <div className="flex items-center justify-between h-16 px-6" data-id="element-33">
        {/* Left side - Dashboard link */}
        <div className="flex items-center" data-id="element-34">
          <button className="text-gray-700 font-medium" data-id="element-35">Dashboard</button>
        </div>
        {/* Right side - User avatar */}
        <div className="flex items-center" data-id="element-36">
          <div className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center text-white" data-id="element-37">
            <span data-id="element-38">N</span>
          </div>
        </div>
      </div>
    </header>;
}